import { I18n } from '@app/i18n/strings-keys';

export const VIEW_MODE_WITHOUT_PERMISSION_COLUMNS = [
  'manager_begin_view',
  'gratis_view',
  'ingredient_spoil_view',
  'end_view',
];

export const EDIT_MODE_WITHOUT_PERMISSION_COLUMNS = [
  'manager_begin_edit',
  'gratis_edit',
  'ingredient_spoil_edit',
  'end_edit',
];

export const VIEW_MODE_WITH_PERMISSION_COLUMNS = ['adjustment_view'];

export const EDIT_MODE_WITH_PERMISSION_COLUMNS = ['adjustment_edit'];

export enum VIEW_MODE_CAPTION {
  VIEW_MODE = 'Edit Counts',
  EDIT_MODE = 'Exit Edit Counts',
}

export const VIEW_MODE_VALUE_OPTIONS = {
  [VIEW_MODE_CAPTION.VIEW_MODE]: I18n.Forms.StandWorksheetForm.EditCounts,
  [VIEW_MODE_CAPTION.EDIT_MODE]: I18n.Forms.StandWorksheetForm.ExitEditCounts,
};
